import React, { useEffect, useRef } from 'react';
import '../styles/interactive-effects.css';

export const InteractiveEffects = () => {
  const glowRef = useRef(null);
  const requestRef = useRef();
  const mousePos = useRef({ x: -1000, y: -1000 });

  useEffect(() => {
    const updateGlow = () => {
      if (glowRef.current) {
        glowRef.current.style.transform = `translate3d(${mousePos.current.x}px, ${mousePos.current.y}px, 0)`;
      }
      requestRef.current = requestAnimationFrame(updateGlow);
    };

    const handleMouseMove = (e) => {
      mousePos.current = { x: e.clientX, y: e.clientY };
    };

    requestRef.current = requestAnimationFrame(updateGlow);
    window.addEventListener('mousemove', handleMouseMove, { passive: true });
    
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      cancelAnimationFrame(requestRef.current);
    };
  }, []);

  useEffect(() => {
    // Optimized Magnetic Button Logic
    const magneticButtons = document.querySelectorAll('.btn-accent, .nav-cta-btn, .btn-outline, .zp-btn-primary');
    
    const handleMagneticMove = (e) => {
      const btn = e.currentTarget;
      const rect = btn.getBoundingClientRect();
      const x = e.clientX - rect.left - rect.width / 2;
      const y = e.clientY - rect.top - rect.height / 2;
      
      // Snappy and fast response with GPU acceleration
      btn.style.transform = `translate3d(${x * 0.15}px, ${y * 0.15}px, 0)`;
    };

    const handleMagneticReset = (e) => {
      e.currentTarget.style.transform = 'translate3d(0, 0, 0)';
    };

    magneticButtons.forEach(btn => {
      btn.addEventListener('mousemove', handleMagneticMove, { passive: true });
      btn.addEventListener('mouseleave', handleMagneticReset, { passive: true });
    });

    return () => {
      magneticButtons.forEach(btn => {
        btn.removeEventListener('mousemove', handleMagneticMove);
        btn.removeEventListener('mouseleave', handleMagneticReset);
      });
    };
  }, []);

  return (
    <div className="interactive-effects-container">
      <div ref={glowRef} className="mouse-glow"></div>
    </div>
  );
};
